export default "__VITE_ASSET__ffc29931__"